import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/**
 * Tipo para as opções do select
 */
type SelectOption = {
  label: string;
  value: string;
};

/**
 * Propriedades do componente de select
 */
export type SelectComponentProps = {
  placeholder: string;
  options: SelectOption[];
  value?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  label?: string;
};

/**
 * Componente de select personalizado
 * 
 * @param {SelectComponentProps} props - Propriedades do componente
 * @returns {JSX.Element} Componente renderizado
 */
export const SelectComponent: React.FC<SelectComponentProps> = ({
  placeholder,
  options,
  value,
  onChange,
  onBlur,
  disabled = false,
  label,
}) => {
  return (
    <div className="flex flex-col">
      {label && (
        <label className="block text-sm font-medium mb-1">{label}</label>
      )}
      <Select
        value={value}
        onValueChange={onChange}
        disabled={disabled}
      >
        <SelectTrigger 
          className="w-full" 
          onBlur={onBlur}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}; 